<script>
export default {
  name: 'renderTemplate',
  props: ['renderTemplate', 'option'],
  methods: {
    createElement() {
      return this.$createElement(...arguments)
    },
  },
  render() {
    return this.option ? this.renderTemplate(this.createElement, this.option) : this.renderTemplate(this.createElement)
  },
}
</script>
